import React from 'react';
import FAQ from 'Custom/FAQ';
import RichText from 'Custom/RichText';
import Container from 'Nori/Container';
import styles from 'Custom/FAQ/index.module.scss';
import FAQHeader from 'Custom/FAQ/FAQHeader';

const FAQWrapper = ({
  questions = [],
  title = '',
  className = '',
  moduleNumber = '00',
  whiteColoredborder = false,
  ...props
}) => (
  <div
    className={`${styles.faqWrapper} ${className}`}
    {...props}
    data-design-visible="visible_vd"
    data-design-type="module"
    data-design-nori_id="Accordion"
    data-design-module_name={title}
    data-design-module_no={moduleNumber}
  >
    <Container className={styles.colWrapper}>
      {title && (
        <RichText>
          <h2 data-qa-tag={`faq-header-${title}`}>{title}</h2>
        </RichText>
      )}
      <FAQ allowMultiple={true}>
        {questions.map((item, index) => {
          const { title: itemTitle, content: itemContent, ...itemRest } = item;
          return (
            <div
              key={`question-${index}`}
              {...itemRest}
              data-qa-tag={`faq-item-${index}`}
            >
              <FAQHeader
                data-design-type="clickAction"
                data-design-label={itemTitle}
                data-design-nori_id="Accordion"
                data-design-module_name={title}
                data-design-module_no={moduleNumber}
                data-design-element_no={`${
                  index < 9 ? '0' + (index + 1) : index + 1
                }`}
                index={index}
                whiteColoredborder={whiteColoredborder}
              >
                {itemTitle}
              </FAQHeader>
              <div className={styles.faqContent}>{itemContent}</div>
            </div>
          );
        })}
      </FAQ>
    </Container>
  </div>
);

export default FAQWrapper;
